// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"415":"35c9607c","741":"40339bbf","780":"35c9607c","914":"35c9607c"}[chunkId] + ".css";
};